import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Divider, Button, Tag, Collapse, Comment, message, Spin, Space } from "antd";
import {
  HomeOutlined, CheckCircleTwoTone, CloseCircleTwoTone, ClockCircleTwoTone, DollarOutlined, RightOutlined, MessageOutlined, FileSearchOutlined, ArrowRightOutlined, PhoneOutlined,
  MailOutlined, UserOutlined, EnvironmentOutlined, BankOutlined, LikeOutlined, CheckCircleOutlined, ClockCircleOutlined, FileTextOutlined, CloseOutlined
} from '@ant-design/icons'; // right!
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import _commonService from '../../modules/commonService';
import StatusTag from '../../components/StatusTag';
import { useHistory, Link } from "react-router-dom";
import moment from "moment";
import { routes } from '../../routes/Routes';
import { LoanOfficerReviewStatusId, UnderReviewStatusId } from '../../constants/DataConstants';
import _LoanOfficerService from '../../modules/LoanOfficerService';
import SidebarLayout from '../BankerUI/SidebarLayout';
import "../BankerUI/BankerDashboard.scss";
const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

const LoanOfficerDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [bankerMonthlySummaryData, setBankerMonthlySummaryData] = useState([]);
  const [unreviewedSummaryData, setUnreviewedSummary] = useState([]);
  const [inprogressSummaryData, setInprogressSummaryData] = useState([]);
  const [revisitSummaryData, setRevisitSummaryData] = useState([]);
  const FirstName = localStorage.getItem("LoanOfficerFirstName");
  const [loanOfficerName] = useState(FirstName);

  const history = useHistory();
  const LoanOfficerId = localStorage.getItem("LoanOfficerId");
  const loanOfficerID = LoanOfficerId ? parseInt(LoanOfficerId) : null;
  const RoleId = Number(localStorage.getItem("RoleId") ?? 0);
  useEffect(() => {
    getBankerDataById()
  }, []);

  const getBankerDataById = async () => {
    try {
      setLoading(true);

      const res = await _LoanOfficerService.getLoanOfficerDashboardSummary(loanOfficerID);

      if (res.data.IsSuccess) {
        setLoading(false);
        setBankerMonthlySummaryData(res?.data?.Obj.monthlySummary);
        setUnreviewedSummary(res?.data?.Obj.unreviewedSummary);
        setInprogressSummaryData(res?.data?.Obj.inprogressSummary);
        setRevisitSummaryData(res?.data?.Obj.revisitSummary);
      } else {
        setLoading(false);
        if (res.data.Message) {
          message.error(res.data.Message);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  console.log(revisitSummaryData)

  const currentMonthYear = _commonService.getCurrentMonthAndYear();

  const handleClickUpdateApplicantStatus = async (item) => {

    if ((item?.IsClear_Completed == true && item?.IsApplicationApproved == true)){
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      return;
    }
    // if (item && item.Application_Status_Id && (item.Application_Status_Id != 4 && item.Application_Status_Id != 5 && item.Application_Status_Id != 8 && item.Application_Status_Id != 9)) {
    if (item && item.Application_Status_Id && (item.Application_Status_Id != 4 && item.Application_Status_Id != 9 && item.Application_Status_Id != 13 && item.Application_Status_Id != 14 && item.Application_Status_Id != 16)) {
      let reqObj = {
        Id: item.Id,
        ApplicationId: item.ApplicationId,
        Application_Status_Id: LoanOfficerReviewStatusId,
        BankerId: null,
        LoanOfficerId: loanOfficerID,
        RoleId: RoleId || null
      }
      setLoading(true);
      try {
        const res = await _BankerService.updateApplicantStatus(reqObj);
        if (res.data.IsSuccess) {
          setLoading(false);
          //message.success(res.data.Message);
          history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
        } else {
          setLoading(false);
          message.error(res.data.Message);
        }
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
      finally {
        setLoading(false);
      }
    } else {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      setLoading(false);
    }
  }

  const onAllApplicationsClick = (flag) => {
    history.push({
      pathname: routes.loanApplicationsForLoanOfficer.path,
      state: { applicationStatusFlag: flag }
    })
  }

  return (
    <Spin spinning={loading}>
      <SidebarLayout>

        <Row gutter={[32, 32]} justify="start" className='bank-dashboard-parent-div' >
          <Col xs={24} sm={24} md={24}>
            <Title level={3}>Hello, {loanOfficerName}!</Title>
            <Title level={5}>Monthly Summary, {currentMonthYear}</Title>
          </Col>

          <Col xs={24} sm={24} md={24}>
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Approved Applications</Text>
                    <div className='cp-iconWrapStyle'>
                      <CheckCircleOutlined />
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApproved || 0}
                    </Title>
                    {/* <Text className='card-footer-label'>Require review</Text> */}
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Unreviewed Applications</Text>
                    <div className='cp-iconWrapStyle'>
                      <CloseOutlined />
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {bankerMonthlySummaryData && bankerMonthlySummaryData.UnreviewedApplication || 0}
                    </Title>
                    {/* <Text className='card-footer-label'>Require review</Text> */}
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>In-Progress Applications</Text>
                    <div className='cp-iconWrapStyle'>
                      <ClockCircleOutlined />
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {bankerMonthlySummaryData && bankerMonthlySummaryData.InProgressApplication || 0}
                    </Title>
                    {/* <Text className='card-footer-label'>Require review</Text> */}
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={6} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Issued Amount</Text>
                    <div className='cp-iconWrapStyle'>
                      <DollarOutlined />
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      $ {bankerMonthlySummaryData && _commonService.formatNumberWithCommas(bankerMonthlySummaryData.IssuedAmount) || 0}
                    </Title>
                    {/* <Text className='card-footer-label'>Require review</Text> */}
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>


          <Col xs={24} sm={24} md={24}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>Unreviewed Applications:  {unreviewedSummaryData.UnreviewedApplicationCount}</Title>
              </Col>
              {unreviewedSummaryData?.listApplicantBankerDashbordUnreviewedModel?.map((unreviewedSummary) => (
                <Col xs={24} sm={24} md={24}>
                  <Card className='banker-dashboard-card-section card-section' key={unreviewedSummary.Id}>
                    <div>
                      <div> <StatusTag statusId={unreviewedSummary.Application_Status_Id} /></div>
                      <Row gutter={[16, 12]} align="middle" className="app-info-row">
                        <Col>
                          <div className="app-icon">
                            <FileTextOutlined />
                          </div>
                        </Col>
                        <Col flex="auto">
                          <Row justify="end" align="middle">
                            {/* <Col>
                            <StatusTag statusId={unreviewedSummary.Application_Status_Id} />
                          </Col> */}
                            <Col>
                              <Button
                                type="link"
                                className="viewAppBtn"
                                onClick={() =>
                                  handleClickUpdateApplicantStatus(unreviewedSummary)
                                }
                              >
                                View Application <ArrowRightOutlined />
                              </Button>
                            </Col>
                          </Row>
                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Application : </Text>
                              <span className="app-info-value">
                                {unreviewedSummary.ApplicationId}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Client : </Text>
                              <span className="app-info-value">
                                {unreviewedSummary.ApplicantName}
                              </span>
                            </Col>
                          </Row>


                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Loan Amount : </Text>

                              <span className="app-info-value">
                                $
                                {_commonService.formatNumberWithCommas(
                                  unreviewedSummary.ApplicantLoanAmount
                                )}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Firm Name : </Text>

                              <span className="app-info-value">

                                {_commonService.formatNumberWithCommas(
                                  unreviewedSummary.SponserCompany || "N/A"
                                )}
                              </span>
                            </Col>
                          </Row>



                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Date & Time : </Text>

                              <span className="app-info-value">
                                {unreviewedSummary?.CreatedDate
                                  ? _commonService.formatDateTimeAMPM(
                                    unreviewedSummary.CreatedDate
                                  )
                                  : "N/A"}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              ))}
              {unreviewedSummaryData && unreviewedSummaryData.UnreviewedApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(11)}
                  >
                    View All Unreviewed Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>In-Progress Applications: {inprogressSummaryData?.InprogressApplicationCount}</Title>
              </Col>
              {
                inprogressSummaryData?.listApplicantBankerDashbordInprogressApplicationModel?.map((inprogressSummary) => (
                  <Col xs={24} sm={24} md={24}>
                    <Card className='banker-dashboard-card-section card-section' key={inprogressSummary.Id}>

                      <Collapse
                        accordion
                        expandIconPosition="end"
                        ghost
                        expandIcon={({ isActive }) => (
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              backgroundColor: "#414957",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "transform 0.3s",
                              transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                            }}
                          >
                            <RightOutlined style={{ color: "white", fontSize: 12 }} />
                          </div>
                        )}
                      >
                        <Panel
                          // collapsible="icon"
                          header={
                            <div>
                              <div>
                                <StatusTag statusId={inprogressSummary.Application_Status_Id} />
                              </div>
                              <Row gutter={[16, 12]} align="middle" className="app-info-row">
                                <Col>
                                  <div className="app-icon">
                                    <FileTextOutlined />
                                  </div>
                                </Col>
                                <Col flex="auto">
                                  <Row justify="end" align="middle">
                                    {/* <Col>
                                    <StatusTag statusId={inprogressSummary.Application_Status_Id} />
                                  </Col> */}
                                    <Col>
                                      <Button
                                        type="link"
                                        className="viewAppBtn"
                                        onClick={() =>
                                          handleClickUpdateApplicantStatus(inprogressSummary)
                                        }
                                      >
                                        View Application <ArrowRightOutlined />
                                      </Button>
                                    </Col>
                                  </Row>
                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Application : </Text>
                                      <span className="app-info-value">
                                        {inprogressSummary.ApplicationId}
                                      </span>
                                    </Col>
                                  </Row>

                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Client : </Text>
                                      <span className="app-info-value">
                                        {inprogressSummary.ApplicantName}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Loan Amount : </Text>

                                      <span className="app-info-value">
                                        $
                                        {_commonService.formatNumberWithCommas(
                                          inprogressSummary.ApplicantLoanAmount
                                        )}
                                      </span>
                                    </Col>
                                  </Row>

                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Firm Name : </Text>

                                      <span className="app-info-value">

                                        {_commonService.formatNumberWithCommas(
                                          inprogressSummary.SponserCompany || "N/A"
                                        )}
                                      </span>
                                    </Col>
                                  </Row>


                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Date & Time : </Text>

                                      <span className="app-info-value">
                                        {inprogressSummary?.CreatedDate
                                          ? _commonService.formatDateTimeAMPM(
                                            inprogressSummary.CreatedDate
                                          )
                                          : "N/A"}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          }
                        >
                          <Row gutter={[16, 16]} justify="space-between" className='comment-section-parent-div card-section' >
                            {inprogressSummary.listApplicationReviewCommentModels?.map((comment, index) => (

                              <Col xs={24} sm={24} md={24}>
                                <Comment
                                  key={index}
                                  className='revisitComment'
                                  avatar={
                                    <MessageOutlined />
                                  }
                                  content={
                                    <div className=''>
                                      {/* <p className='mb10'><strong>Remarks:</strong> {comment.Remarks || "N/A"}</p> */}
                                      {/* <p className='mb10' ><strong>Comments:</strong> {comment.Comments || "N/A"}</p>
                                      <p className='mb10'><strong>Date & Time:</strong> {comment.ReviewCommentDate ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate) : "N/A"}</p> */}

                                      <p className="mb8">
                                        <strong className="app-info-label">Comments: </strong>
                                        <span className="app-info-value">
                                          {comment.Comments || "N/A"}
                                        </span>
                                      </p>
                                      <p className="">
                                        <strong className="app-info-label">Date & Time: </strong>
                                        <span className="app-info-value">
                                          {comment.ReviewCommentDate
                                            ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate)
                                            : "N/A"}
                                        </span>
                                      </p>

                                    </div>
                                  }
                                />
                              </Col>
                            ))}
                          </Row>
                        </Panel>
                      </Collapse>
                    </Card>
                  </Col>
                ))
              }
              {inprogressSummaryData && inprogressSummaryData.InprogressApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(12)}
                  >
                    View All In Progress Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>Revisit Applications: {revisitSummaryData.RevisitApplicationCount}</Title>
              </Col>
              {
                revisitSummaryData?.listApplicantBankerDashbordRevisitApplicationModel?.map((revisitSummary) => (
                  <Col xs={24} sm={24} md={24}>
                    <Card className='banker-dashboard-card-section card-section' key={revisitSummary.Id}>

                      <Collapse
                        accordion
                        expandIconPosition="end"
                        ghost
                        expandIcon={({ isActive }) => (
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              backgroundColor: "#414957",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "transform 0.3s",
                              transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                            }}
                          >
                            <RightOutlined style={{ color: "white", fontSize: 12 }} />
                          </div>
                        )}
                      >
                        <Panel
                          // collapsible="icon"
                          header={
                            <div>
                              <div><StatusTag statusId={revisitSummary.Application_Status_Id} /></div>
                              <Row gutter={[16, 12]} align="middle" className="app-info-row">
                                <Col>
                                  <div className="app-icon">
                                    <FileTextOutlined />
                                  </div>
                                </Col>
                                <Col flex="auto">
                                  <Row justify="end" align="middle">
                                    {/* <Col>
                                      <StatusTag statusId={revisitSummary.Application_Status_Id} />
                                    </Col> */}
                                    <Col>
                                      <Button
                                        type="link"
                                        className="viewAppBtn"
                                        onClick={() =>
                                          handleClickUpdateApplicantStatus(revisitSummary)
                                        }
                                      >
                                        View Application <ArrowRightOutlined />
                                      </Button>
                                    </Col>
                                  </Row>
                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Application : </Text>
                                      <span className="app-info-value">
                                        {revisitSummary.ApplicationId}
                                      </span>
                                    </Col>
                                  </Row>

                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Client : </Text>
                                      <span className="app-info-value">
                                        {revisitSummary.ApplicantName}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Loan Amount : </Text>

                                      <span className="app-info-value">
                                        $
                                        {_commonService.formatNumberWithCommas(
                                          revisitSummary.ApplicantLoanAmount
                                        )}
                                      </span>
                                    </Col>
                                  </Row>

                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Firm Name : </Text>

                                      <span className="app-info-value">

                                        {_commonService.formatNumberWithCommas(
                                          revisitSummary.SponserCompany || "N/A"
                                        )}
                                      </span>
                                    </Col>
                                  </Row>


                                  <Row className="app-info">
                                    <Col xs={24} sm={24} md={24}>
                                      <Text className='app-info-label'>Date & Time : </Text>

                                      <span className="app-info-value">
                                        {revisitSummary?.CreatedDate
                                          ? _commonService.formatDateTimeAMPM(
                                            revisitSummary.CreatedDate
                                          )
                                          : "N/A"}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          }
                        >

                          <Row gutter={[16, 16]} justify="space-between" className='comment-section-parent-div card-section' >
                            {revisitSummary.listApplicationReviewCommentModels?.map((comment, index) => (

                              <Col xs={24} sm={24} md={24}>
                                <Comment
                                  key={index}
                                  className='revisitComment'
                                  avatar={
                                    <MessageOutlined />
                                  }
                                  content={
                                    <div className=''>
                                      {/* <p className='mb10'><strong>Remarks:</strong> {comment.Remarks || "N/A"}</p> */}
                                      {/* <p className='mb10' ><strong>Comments:</strong> {comment.Comments || "N/A"}</p>
                            <p className='mb10'><strong>Date & Time:</strong> {comment.ReviewCommentDate ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate) : "N/A"}</p> */}

                                      <p className="mb8">
                                        <strong className="app-info-label">Comments : </strong>
                                        <span className="app-info-value">
                                          {comment.Comments || "N/A"}
                                        </span>
                                      </p>
                                      <p className="">
                                        <strong className="app-info-label">Date & Time : </strong>
                                        <span className="app-info-value">
                                          {comment.ReviewCommentDate
                                            ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate)
                                            : "N/A"}
                                        </span>
                                      </p>

                                    </div>
                                  }
                                />
                              </Col>
                            ))}
                          </Row>
                        </Panel>
                      </Collapse>
                    </Card>
                  </Col>
                ))
              }
              {revisitSummaryData && revisitSummaryData.RevisitApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(1)}
                  >
                    View All Revisit Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>
        </Row>
      </SidebarLayout>
    </Spin>
  );
};

export default LoanOfficerDashboard;
